/**
 * Shop ICP ("who it's for") content — homeowner, property manager, electrician.
 * Ported from the driver store's StoreWhyPage so the public shop reuses the
 * same voice + UGC. Pure data (no React / no in-app coupling); each app renders
 * it with its own chrome and CTA targets. The media paths resolve from each
 * app's own /public.
 */
export const SHOP_ICPS = [
    {
        slug: 'homeowner',
        eyebrow: 'Homeowners',
        video: '/media/ugc/homeowner.mp4',
        poster: '/media/ugc/homeowner-poster.jpg',
        tile: '/media/ugc/homeowner-tile.webp',
        title: 'Charge at home. Wake up full.',
        body: 'Your garage becomes your gas station. The EVI app starts your charge, tracks '
            + 'every kilowatt hour, and shows you exactly what it costs. Add your family to '
            + 'your free pass list and they charge free too. Buy the charger, plug in, and '
            + 'the app walks you through setup in minutes.',
        quotes: [
            {
                text: 'I plug in at night and stop thinking about it. The app shows me every '
                    + 'session and my husband charges on my free pass list for nothing.',
                name: 'Sienna R., homeowner, Sacramento CA',
            },
            {
                text: 'Setup took one evening. The charger showed up, my electrician mounted '
                    + 'it, and the app found it on the first try.',
                name: 'Dana M., homeowner, Mesa AZ',
            },
        ],
        ctaLabel: 'Shop home chargers',
        ctaSlug: 'home-charging',
        framing: 50,
    },
    {
        slug: 'property-manager',
        eyebrow: 'Property managers',
        video: '/media/ugc/property-manager.mp4',
        poster: '/media/ugc/property-manager-poster.jpg',
        tile: '/media/ugc/property-manager-tile.webp',
        // Portrait still, tall subject; bias the tile crop up so his face shows.
        tileFraming: 25,
        title: 'Amenity income, not amenity overhead.',
        body: 'Your residents want charging. EVI makes it pay. Set your rate, and the '
            + 'platform bills drivers, pays you out through Stripe, and hands you the '
            + 'reports your owner wants to see. No attendant, no billing spreadsheet, no '
            + 'service calls routed through your office. Residents charge with the app, '
            + 'guests pay your markup, and you watch it all from your phone.',
        quotes: [
            {
                text: 'Two pedestals in the visitor lot went from a cost line to a revenue '
                    + 'line. The payout hits our account and the report goes straight to ownership.',
                name: 'Sterling J., property manager, Atlanta GA',
            },
            {
                text: 'Residents stopped emailing me about charging. The app handles access, '
                    + 'billing, and the one dispute we had came with the session record attached.',
                name: 'Priya K., community manager, Charlotte NC',
            },
        ],
        ctaLabel: 'Shop commercial chargers',
        ctaSlug: 'commercial-ac',
        framing: 36,
    },
    {
        slug: 'electrician',
        eyebrow: 'Electricians & installers',
        video: '/media/ugc/electrician.mp4',
        poster: '/media/ugc/electrician-poster.jpg',
        tile: '/media/ugc/electrician-tile.webp',
        title: 'Install it once. Earn on it forever.',
        body: 'Every charger you install on EVI keeps working for you. Commission the '
            + 'hardware, hand the customer an app that runs itself, and stop fielding '
            + 'support calls for free. Clean OCPP hardware, drop-ship delivery to the job '
            + 'site, and a network that makes you look good on every install.',
        quotes: [
            {
                text: 'I quoted the install, EVI drop-shipped the unit to the site, and it was '
                    + "on the network the same day. The customer thinks I'm a wizard.",
                name: 'Brooks T., licensed electrician, Tampa FL',
            },
            {
                text: 'The partner commission turned my install business into recurring '
                    + 'income. Every unit I put on a wall keeps paying.',
                name: 'Marco V., EV installer, Orlando FL',
            },
        ],
        ctaLabel: 'Shop commercial chargers',
        ctaSlug: 'commercial-dc',
        framing: 36,
        salesPartner: true,
    },
];
export function shopIcpBySlug(slug) {
    return SHOP_ICPS.find((i) => i.slug === slug) ?? null;
}
//# sourceMappingURL=icp.js.map